export default __webpack_public_path__ + "static/media/Img034.a3c1dbbe.jpg";